module.exports = __webpack_public_path__ + "img/bridegroom-face.08a62cdc.png";